import { Quaternion } from "@babylonjs/core/Maths/math.vector";
import { MoveWallAddition } from "./tools";
import { AbstractInteractors } from "./interactors";
import { EditWallAddition } from "../cmd/EditWallAddition";
import { Util } from "../utils/Util";
import { InteractorType } from '@egr/wcf/modules/core/tool';
import { PI_DIV2 } from "@egr/wcf/modules/utils/math";
import { getRotationQuaternion } from "@egr/wcf/modules/core/utils/MeshUtils";
import { perpendicularVector2, VECTOR3_X } from '@egr/wcf/modules/core/utils/MathUtils';
export class WallAdditionInteractors extends AbstractInteractors {
    constructor(pRoomManager, pAddition) {
        super(pRoomManager);
        this.mAddition = pAddition;
        this.mDistInteractors = [null, null, null, null];
    }
    // tslint:disable-next-line:cyclomatic-complexity
    showInteractors(pShow) {
        this.clear();
        if (!pShow || this.mApp.model.selection.length !== 1)
            return;
        this.mInteractorManager.enabled = true;
        let tDir = this.mAddition.getEdge(1, false).subtract(this.mAddition.getEdge(0, false)).normalize();
        let tDirP = perpendicularVector2(tDir);
        let t3dRotation = getRotationQuaternion(this.mAddition.node).clone();
        let t3dRotation1 = getRotationQuaternion(this.mAddition.node).clone();
        t3dRotation1.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        let tPos_Y = this.mAddition.node.position.clone();
        tPos_Y.addInPlace(this.mAddition.getGeometryOffset_Z());
        let tPos_0 = this.mAddition.node.position.clone();
        tPos_0.addInPlace(this.mAddition.getGeometryOffset_Z());
        if (this.mAddition.type == "PictureFrame") {
            tPos_Y.y = this.mAddition.floorOffset;
        }
        if (this.mAddition.type == "Radiator") {
            t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        }
        //move
        let tInteractor = this.createInteractor("move-interactor", tPos_Y, null, 0, t3dRotation, false, true);
        tInteractor.onTriggerAction = () => this.startMoveAddition();
        if (this.mAddition.type == "PictureFrame" && this.mRoomManager.viewMode == 0) {
            tInteractor = this.createInteractor("move-interactor", tPos_Y, null, 0, t3dRotation1, false, true);
            tInteractor.onTriggerAction = () => this.startMoveAddition();
        }
        //mirror
        if ((this.mAddition.geometry.canMirrorV || this.mAddition.geometry.canMirrorH) &&
            this.mRoomManager.MirrorInteractorVisible) {
            let tOffset = this.mAddition.mirrorHorizontal ? -22 : 22;
            tInteractor = this.createInteractor("mirror-interactor", tPos_0, Util.to3d(tDirP).normalize(), tOffset, t3dRotation1, true);
            tInteractor.type = InteractorType.Button;
            tInteractor.onTriggerAction = () => this.mirrorAddition();
            tInteractor.updateViewPosition();
        }
        //distance text interactors
        this._updateDistInteractors();
    }
    clear() {
        this.mInteractorManager.clear();
        this.mInteractorManager.enabled = false;
        this.mDistInteractors = [null, null, null, null];
    }
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    _updateDistInteractors() {
        this.mInteractorManager.enabled = true;
        let t3dRotation = getRotationQuaternion(this.mAddition.node).clone();
        t3dRotation.multiplyInPlace(Quaternion.RotationAxis(VECTOR3_X, PI_DIV2));
        if (this.mAddition.wall != null) {
            let tWall = this.mAddition.wall;
            let tDir = tWall.endPoint.subtract(tWall.startPoint).normalize();
            let tDirP = perpendicularVector2(tDir);
            for (let i = 0; i < 4; i++) {
                let tDist = this.mAddition._getDistanceEdge(i);
                let tPos = this.getDistTextPos(i, tDist);
                let tOffset = i >= 2 ? -15 : 15;
                if (Math.abs(tDist) > 0.01) {
                    let tInteractor = this.createTextInteractor(Util.to3d(tPos), this.lengthToString(tDist), Util.to3d(tDir).normalize(), Util.to3d(tDirP).normalize(), tOffset, t3dRotation, false, this.mDistInteractors[i]);
                    tInteractor.onTriggerAction = () => this.showInputField(WallAdditionInteractors.INPUT_DIST, tDist, tInteractor);
                    tInteractor._edge = i;
                    this.mDistInteractors[i] = tInteractor;
                }
            }
        }
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    handleInputField(pId, pOldLength, pNewLength, pInteractor) {
        if (pId === WallAdditionInteractors.INPUT_DIST)
            this.setDistanceEdge(pInteractor._edge, pOldLength, pNewLength);
    }
    getDistTextPos(pDistIterator, pDistance) {
        let tV1 = this.mAddition.getEdge(pDistIterator, false);
        let tV2;
        switch (pDistIterator) {
            case 0:
                tV2 = this.mAddition.getEdge(1, false);
                break;
            case 1:
                tV2 = this.mAddition.getEdge(0, false);
                break;
            case 2:
                tV2 = this.mAddition.getEdge(3, false);
                break;
            default: //3
                tV2 = this.mAddition.getEdge(2, false);
                break;
        }
        let tVDir = tV1.subtract(tV2).normalize();
        let tV = tV1.add(tVDir.scaleInPlace(pDistance / 2));
        return (tV);
    }
    startMoveAddition() {
        let tTool = new MoveWallAddition(this.mRoomManager);
        tTool.initialize(this.mAddition);
        this.mApp.tools.startTool(tTool);
    }
    mirrorAddition() {
        let tCmd = new EditWallAddition(this.mRoomManager, this.mAddition);
        if (this.mAddition.geometry.canMirrorV && this.mAddition.geometry.canMirrorH) {
            let tH = this.mAddition.mirrorHorizontal;
            let tV = this.mAddition.mirrorVertical;
            if (tH && tV)
                this.mAddition.setMirrorVertical(false);
            else if (tH)
                this.mAddition.setMirrorHorizontal(false);
            else if (tV)
                this.mAddition.setMirrorHorizontal(true);
            else
                this.mAddition.setMirrorVertical(true);
        }
        else if (this.mAddition.geometry.canMirrorV) {
            this.mAddition.setMirrorVertical(!this.mAddition.mirrorVertical);
        }
        else if (this.mAddition.geometry.canMirrorH) {
            this.mAddition.setMirrorHorizontal(!this.mAddition.mirrorHorizontal);
        }
        this.mApp.commands.executeCommand(tCmd);
    }
    setDistanceEdge(pEdge, pOldDist, pDist) {
        let tDiff = pDist - pOldDist;
        let tNewPos;
        let tWall = this.mAddition.wall;
        if (tWall == null)
            return;
        if (pEdge == 0 || pEdge == 3) {
            let tV1 = this.mAddition.position.subtract(tWall.startPoint);
            let tOldLength = tV1.length();
            tV1 = tWall.endPoint.subtract(tWall.startPoint).normalize();
            tV1.scaleInPlace(tOldLength + tDiff);
            tNewPos = tV1.add(tWall.startPoint);
        }
        else {
            let tV1 = this.mAddition.position.subtract(tWall.endPoint);
            let tOldLength = tV1.length();
            tV1 = tWall.startPoint.subtract(tWall.endPoint).normalize();
            tV1.scaleInPlace(tOldLength + tDiff);
            tNewPos = tV1.add(tWall.endPoint);
        }
        let tCmd = new EditWallAddition(this.mRoomManager, this.mAddition);
        this.mAddition.setPosition(tNewPos);
        this.mApp.commands.executeCommand(tCmd);
    }
}
//// private ///////////////////////////////////////////////////////////////////////////////
WallAdditionInteractors.INPUT_DIST = "WallAddition:distance_edge";
